import $ from "@modules/jquery";
import { gsap } from "@modules/gsap";
import { ScrollToPlugin } from "@modules/gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);


export default function ScrollToTop() {

    if ($(window).width() > 768) {

        $('#scroll-to-top').on('click', function () {
            gsap.to(window, {
                scrollTo: 0,
                duration: 0.3,
                ease: "linear"
            });
        });

        const $scroll_to_top_container = $('.scroll-to-top-container');

        if ($scroll_to_top_container.length > 0) {
            $(window).scroll(function () {
                if ($(this).scrollTop() >= 200) {
                    if (!$scroll_to_top_container.hasClass('fixed')) {
                        $scroll_to_top_container.addClass('fixed');
                    }
                } else {
                    $scroll_to_top_container.removeClass('fixed');
                }
            });
        }
    }
}
